module.exports = "/_next/static/images/bg-badge-2dbae5d90c582880baf39b281e389be7.jpg";